import apiRequestType from "../../apiRequestType";
import { apiTypes } from "../../../utils/apiTypes";
import { apiConstants } from "../../../utils/apiConstants";

const updateShotClassSourcing = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.SOCIAL.MODERATE_CONTRIBUTIONS.UPDATE_SHOTCLASS,
    data
  );
};

export default updateShotClassSourcing;
